$(window).on('load', function(){
	var link = location.href.split('/').pop();
	link = link.split('?');
	link = link[0].toLowerCase();

	console.log(link);
	$('.menu li[data-link="' + link + '"] a').addClass('active');

	setTimeout(function() {
		if(!$('.membershipbuy-wrapper').length){
			$('body').addClass('loaded');
		}
	}, 500);
})